import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';

export default function CustomPasswordFormField({ label, handleOnFieldChange, name, onBlur, onFocus, errorClass }) {
  const [showCrypticField, setShowCrypticField] = useState(true);
  const passwordFieldRef = useRef();

  useEffect(() => {
    if (!showCrypticField && passwordFieldRef.current) {
      passwordFieldRef.current.focus();
    }
  }, [showCrypticField]);

  const handleOnFocus = () => {
    setShowCrypticField(false);
  };

  const onApiKeyChange = (event) => {
    if (onBlur) {
      onBlur(event);
    }

    const textValue = event.target.value;
    if (textValue.length <= 0) {
      setShowCrypticField(true);
    }
    handleOnFieldChange(textValue);
  };

  return (
    <div className="form-group">
      <label htmlFor="password-field">
        {label}
        {showCrypticField ? (
          <input
            id="password-field"
            name="password-field-crypto"
            key="password-field-crypto"
            onFocus={handleOnFocus}
            onChange={handleOnFocus}
            value="&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;"
          />
        ) : (
          <input
            className={errorClass}
            ref={passwordFieldRef}
            id="password-field"
            name={name}
            key="password-field"
            onChange={onApiKeyChange}
            onBlur={onApiKeyChange}
            onFocus={onFocus}
          />
        )}
      </label>
    </div>
  );
}

CustomPasswordFormField.defaultProps = {
  name: 'password-field',
  errorClass: '',
  onBlur: null,
  onFocus: null,
};

CustomPasswordFormField.propTypes = {
  handleOnFieldChange: PropTypes.func.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  errorClass: PropTypes.string,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
};
